const palette = {
    turquoise: "#1abc9c",
    greenSea: "#16a085",
    sunFlower: "#f1c40f",
    orange: "#f39c12",
    emerals: "#2ecc71",
    nephritis: "#27ae60",
    carrot: "#e67e22",
    pumpkin: "#d35400",
    peterRiver: "#3498db",
    belizeHole: "#2980b9",
    alizarin: "#C0392B",
    pomegranate: "#c0392b",
    amethyst: "#9b59b6",
    wisteria: "#8e44ad",
    clouds: "#ecf0f1",
    silver: "#bdc3c7",
    wetAsphalt: "#34495e",
    midnightBlue: "#2c3e50",
    concrete: "#95a5a6",
    asbestos: "#7f8c8d",
};

export default palette;
